import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { audiosAssets } from '../../assets/audio';
import { ButtonPlay } from '../../components/common/ButtonPlay';
import { ButtonHome } from '../../components/common/ButtonHome';
import { SelectorCharacterUI } from '../introduction/SelectorCharacterUI';
import { DialogBarNew } from '../../components/common/DialogBarNew';
import { voicesTypeControl } from '../../types/audioType';


const steps = {
	selectCharacter: 1,
	dialogInitial: 2,
	dialogTwo: 3,
};

export const Theme9Introduction = () => {
	const { loaded } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);

	useEffect(() => {
		if (loaded) {
			console.log("theme 9 intro");
			ObserverEmitter.emit(EVENTS.tema9.introduction, 0);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.introduccion.intro01)
						setUiToShow(steps.dialogInitial);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogInitial && (
				<>
					<DialogBarNew
						dialog={
							`Los objetivos del tema es conocer las actividades que realiza un Colaborador en Tienda con la finalidad de aplicarlas en su día a día.`
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.introduccion.intro02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						`Al realizar las actividades y misiones que se presentan durante el recorrido obtendrás puntos que miden tu aprendizaje.`
					}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						window.location.href = "/home9/tema9/subtema1/activityOne"
					}}
				></DialogBarNew>
			)}

		</>
	)
}
